"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagArtefact = void 0;
class TagArtefact {
    constructor(data) {
        this.text = null;
        this.backgroundColor = null;
        this.textColor = null;
        this.category = null;
        if (data) {
            data = (typeof data === "string") ? JSON.parse(data) : data;
            this.text = data.text;
            this.backgroundColor = data.tagColor && !data.hasOwnProperty('category') ? `#${this.lightenDarkenColor(data.tagColor.split('#')[1], 150)}` : '#F5F4FC';
            this.textColor = data.tagColor || '#C41723';
            this.category = (data.hasOwnProperty('category')) ? data.category : null;
        }
    }
    lightenDarkenColor(col, amt) {
        var usePound = false;
        if (col[0] == "#") {
            col = col.slice(1);
            usePound = true;
        }
        var num = parseInt(col, 16);
        var r = (num >> 16) + amt;
        if (r > 255)
            r = 255;
        else if (r < 0)
            r = 0;
        var b = ((num >> 8) & 0x00FF) + amt;
        if (b > 255)
            b = 255;
        else if (b < 0)
            b = 0;
        var g = (num & 0x0000FF) + amt;
        if (g > 255)
            g = 255;
        else if (g < 0)
            g = 0;
        return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    }
}
exports.TagArtefact = TagArtefact;
//# sourceMappingURL=TagArtefact.js.map